/**
 * Status Panel Icons
 *
 * Collection of SVG icon components for AI Avatar status panel.
 * All icons use currentColor for easy theming via CSS.
 */

export { default as ConnectingIcon } from './ConnectingIcon';
export { default as MicIcon } from './MicIcon';
export { default as ThinkingIcon } from './ThinkingIcon';
export { default as AnsweringIcon } from './AnsweringIcon';
export { default as DefaultIcon } from './DefaultIcon';
export { default as PhoneOffIcon } from './PhoneOffIcon';
export { default as MessageIcon } from './MessageIcon';
